export enum ADMIN_TRIGGER {
    Login = "!login",
    Logout = "!logout"
}